module.exports = __webpack_public_path__ + "static/media/PM39.5b54142a.png";